import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider, { useAuth } from './contexts/AuthContext';
import { WalletContextProvider } from './contexts/WalletContextProvider';
import { SwipePreferencesProvider } from './contexts/SwipePreferencesContext';
import Layout from './components/Layout/Layout';
import { Home } from './pages/Home';
import Profile from './pages/Profile';
import { Messages } from './pages/Messages';
import { TokenSearch } from './pages/TokenSearch';
import { NFTs } from './pages/NFTs';
import { Settings } from './pages/Settings';
import { PostDetail } from './pages/PostDetail';
import { SpacePage } from './pages/SpacePage';
import Tokens from './pages/Tokens';
import { LoadingScreen } from './components/UI/LoadingScreen';
import { WelcomeModal } from './components/UI/WelcomeModal';
// import CommunityCreate from './pages/CommunityCreate';
// import CommunityView from './pages/CommunityView';
// import CommunityList from './pages/CommunityList';
import './index.css';

// Composant principal de l'app avec la logique des modals
const AppContent: React.FC = () => {
  const { user, loading: authLoading } = useAuth();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [hasSeenWelcome, setHasSeenWelcome] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà vu le modal de bienvenue
    const hasSeenWelcomeBefore = localStorage.getItem('jupipotes_welcome_seen');
    setHasSeenWelcome(!!hasSeenWelcomeBefore);
  }, []);

  useEffect(() => {
    // Gérer l'affichage du modal de bienvenue après le chargement initial
    if (!isInitialLoading && !authLoading) {
      if (!user) { // Forcer l'affichage du modal si pas d'utilisateur connecté
        setShowWelcomeModal(true);
      }
    }
  }, [isInitialLoading, authLoading, user]);

  const handleLoadingComplete = () => {
    setIsInitialLoading(false);
  };

  const handleWelcomeClose = () => {
    setShowWelcomeModal(false);
    localStorage.setItem('jupipotes_welcome_seen', 'true');
    setHasSeenWelcome(true);
  };

  // Afficher l'écran de chargement initial
  if (isInitialLoading) {
    return <LoadingScreen isLoading={true} onComplete={handleLoadingComplete} />;
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/post/:postId" element={<PostDetail />} />
          <Route path="/community/:communityId/post/:postId" element={<PostDetail />} />
          <Route path="/spaces/:spaceId" element={<SpacePage />} />
          <Route path="/profile/:userId?" element={<Profile />} />
          <Route path="/messages" element={<Messages />} />
          {/* <Route path="/tokenSearch" element={<TokenSearch />} /> */}
          {/* <Route path="/tokens" element={<Tokens />} /> */}
          {/* <Route path="/nfts" element={<NFTs />} /> */}
          <Route path="/settings" element={<Settings />} />
          <Route path="/JUPResources" element={require('./pages/JUPResources').default ? React.createElement(require('./pages/JUPResources').default) : null} />
          <Route path="/help" element={require('./pages/HelpCenter').default ? React.createElement(require('./pages/HelpCenter').default) : null} />
          <Route path="/community-dao" element={require('./pages/CommunityDAO').default ? React.createElement(require('./pages/CommunityDAO').default) : null} />
          <Route path="/about-jup" element={require('./pages/AboutJUP').default ? React.createElement(require('./pages/AboutJUP').default) : null} />
          <Route path="/support" element={require('./pages/Support').default ? React.createElement(require('./pages/Support').default) : null} />
          <Route path="/privacy-policy" element={require('./pages/PrivacyPolicy').default ? React.createElement(require('./pages/PrivacyPolicy').default) : null} />
          <Route path="/terms-of-service" element={require('./pages/TermsOfService').default ? React.createElement(require('./pages/TermsOfService').default) : null} />
          <Route path="/gaming" element={require('./pages/Gaming').Gaming ? React.createElement(require('./pages/Gaming').Gaming) : null} />
          {/* <Route path="/communities" element={<CommunityList />} />
          <Route path="/communities/create" element={<CommunityCreate />} />
          <Route path="/communities/:id" element={<CommunityView />} /> */}
          <Route path="/admin" element={React.createElement(require('./pages/AdminDashboard').default)} />
          
        </Routes>
      </Layout>
      {/* Modal de bienvenue pour les utilisateurs non connectés */}
      <WelcomeModal 
        isOpen={showWelcomeModal} 
        onClose={handleWelcomeClose} 
      />
    </>
  );
};

function App() {
  return (
    <WalletContextProvider>
      <AuthProvider>
        <SwipePreferencesProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <AppContent />
          </Router>
        </SwipePreferencesProvider>
      </AuthProvider>
    </WalletContextProvider>
  );
}

export default App;
